import { BooleanQueryOperator, Filter } from '../store/common/search/types';

export interface TabItem {
    id: string;
    value: string;
    text?: any;
    category?: string;
    isTitleEditable?: boolean;
    disabled?: boolean;
}

export interface TabData {
    id: string;
    category: string;
    dataType: string;
    name?: string;
    filters: Filter[];
    booleanQueryOperator?: BooleanQueryOperator;
    // source tab id for overridden tabs
    sourceId?: string;
    [key: string]: any;
}

export interface TabInfo {
    tab: TabSetting;
    isTitleEditable: boolean;
    filterId?: number;
}

export interface TabSetting extends TabData {
    workspaceRef?: string;
}

export enum Categories {
    DEFAULT = 'default',
    OVERRIDE = 'overridden',
    CUSTOM = 'custom',
}

export interface CustomListSetting {
    name: string;
    dataType: string;
    columns: any[];
    workspaceRef?: string;
    filterId?: number;
    [key: string]: any;
}
